/**
 * Learner dashboard page.
 */
import React from "react";
import { Grid } from "@mui/material";

import DashboardStatistic from "./dashboard.statistic";
import DashboardHeader from "./dashboard.header";
import DashboardGroup from "./dashboard.group";
import DashboardNetwork from "./dashboard.network";
import DashboardSummary from "./dashboard.summary";
import DashboardContent from "./dashboard.content";
import DashboardSimilar from "./dashboard.similar";
import DashboardAlert from "./dashboard.alert";

/**
 * Composes dashboard header, alerts, content, and similar-course widgets.
 */
const Dashboard = () => {
  return (
    <div className="v-bg-body h-full">
      <DashboardHeader />
      <DashboardAlert />
      <DashboardStatistic />
      <Grid container spacing={3} className="mx-auto w-full md:w-10/12 px-4 pb-10">
        <Grid item xs={12} lg={9} className="px-2 md:px-0">
          <DashboardContent />
          <DashboardSimilar />
        </Grid>

        <Grid item xs={12} lg={3} className="pl-0 lg:pl-6">
          <DashboardSummary />
          <DashboardGroup />
          <DashboardNetwork />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
